import React from 'react'
import GenericGrid from '../../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useLocation from './useLocation'

const LocationSummary = () => {
  const defaultFetchParameter = {
    include: ['stats'],
    sort: '+name',
    exclude_containers: true,
    page: 0,
    per_page: 20
  }
  const {
    loadLocations,
    listAssetTypes,
    bulkUpdateLocationsCallBack,
    entityDisplayNameFromParams
  } = useLocation()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper('Location', bulkUpdateLocationsCallBack)

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 200, sortable: true },
    { field: 'type', headerName: 'Type', width: 200, sortable: true },
    { field: 'total_contracts', headerName: 'Accounts', width: 150, sortable: true },
    { field: 'total_parties', headerName: 'Contacts', width: 150, sortable: true },
    { field: 'total_entities', headerName: 'Entities', width: 150, sortable: true },
    { field: 'total_assets', headerName: 'Locations', width: 150, sortable: true },
    {
      field: 'active',
      headerName: 'Status',
      width: 200,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    // NOTE,
    // This is NOT how REACT is supposed to work. Due to the unfortunate
    // bad architecture of a previous UI team, we've had to do a bunch
    // of sub-optimal workarounds ahead of a rewrite.
    const [respAssets, assetTypes] = await Promise.all([
      loadLocations(arg),
      listAssetTypes()
    ]) 

    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = respAssets

    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        type: assetTypes.find(t => t.id === one.type_id)?.name,
        description: one.description,
        total_contracts: one.stats.find(r => r.type === 'contracts')?.count,
        total_parties: one.stats.find(r => r.type === 'parties')?.count,
        total_entities: one.stats.find(r => r.type === 'entities')?.count,
        total_assets: one.stats.find(r => r.type === 'assets')?.count,
        active: one.suspended_at ? false : true
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={'Locations'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          typeToTypeDisplayName={entityDisplayNameFromParams}
          containedEntityType={'NA'}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default LocationSummary
